import React, { useEffect, useState } from "react";
import { CloseButton, StatusMessage } from "../../style/view.styles";
import LoadingSpinner from "./LoadingSpinner";
import { getLoggedInProfile } from "../../utils/AuthHandler";
import { fetchEntityData, saveEntityData } from "../../utils/RequestHandler";
import {
  FormContainer,
  StyledForm,
  StyledFormField,
  StyledLabel,
  StyledTextarea,
  Title,
} from "../../style/modal.form.style";
import { FaMessage } from "react-icons/fa6";
import FullButton from "../Buttons/FullButton";

const MentorshipApplicationForm = ({
  selectedMentor,
  handleModalClose,
  setIsConnectionSent,
}) => {
  const [loading, setLoading] = useState(true);
  const [applicationStatus, setApplicationStatus] = useState(null);
  const [applicantId, setApplicantId] = useState(null);
  const [formData, setFormData] = useState({
    note: "",
  });
  const [formStatus, setFormStatus] = useState({ message: "", type: "" });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const setDefaultStatus = async () => {
      try {
        const response = await fetchEntityData("application_status");
        if (response.success) {
          setApplicationStatus(
            response.result.find((item) => item.status === "new").id
          );
        }
      } catch (error) {
        console.error(error);
      }
    };

    const setApplicant = async () => {
      try {
        const applicant = await getLoggedInProfile();
        if (applicant) setApplicantId(applicant.id);
        setLoading(false);
      } catch (error) {
        console.error(error);
      }
    };

    setDefaultStatus();
    setApplicant();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormSubmit = async () => {
    try {
      const requestData = {
        ...formData,
        applicant: applicantId,
        mentor: selectedMentor.id,
        status: applicationStatus,
      };
      const response = await saveEntityData(
        "mentorship_applications",
        requestData
      );
      if (response.success) {
        setFormStatus({
          message: "Application sent successfully!",
          type: "success",
        });
        setSubmitting(false);
        setIsConnectionSent(true);
        handleModalClose();
      } else {
        setFormStatus({
          message:
            response.message ??
            "An error occurred while submitting your request. Please try again.",
          type: "error",
        });
      }
    } catch (error) {
      console.error(error);
      setFormStatus({
        message:
          "An error occurred while submitting your request. Please try again.",
        type: "error",
      });
    }
  };

  return (
    <FormContainer>
      <CloseButton onClick={handleModalClose}>×</CloseButton>
      <Title>Request mentorship from {selectedMentor?.fullname}</Title>
      <StyledForm>
        {loading && <LoadingSpinner />}
        {!loading && (
          <StyledFormField fullWidth>
            <StyledLabel>
              <FaMessage style={{ marginRight: 5 }} /> Note
            </StyledLabel>
            <StyledTextarea
              name="note"
              placeholder="Write a brief message to introduce yourself"
              rows="4"
              value={formData.note}
              onChange={handleInputChange}
              required
            />
          </StyledFormField>
        )}
      </StyledForm>
      <FullButton
        action={handleFormSubmit}
        type="submit"
        disabled={submitting}
        title={submitting ? "Sending..." : "Send Request"}
      />
      {formStatus.message && (
        <StatusMessage type={formStatus.type}>
          {formStatus.message}
        </StatusMessage>
      )}
    </FormContainer>
  );
};

export default MentorshipApplicationForm;
